export const WD = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

/** ISO-Wochentag (1=Montag…7=Sonntag, wie `TrainingSeries.weekdays`) aus
 * `eventDate` (YYYY-MM-DD) — für Wochentag-Filter (Training, Trainer-Arbeitsseite). */
export function isoWeekday(eventDate: string): number {
  const day = new Date(`${eventDate}T00:00:00`).getDay();
  return day === 0 ? 7 : day;
}
